
(function () {
	document.addEventListener("DOMContentLoaded", () => {

		if (!document.querySelectorAll(".vg-faqs")) return;
		if (!document.querySelector(".vg-contact-form")) return;

		document.addEventListener("click", (event) => {
			const item = event.target;

			if (!item) return;

			if (handleFaqsSelection(item)) return;
		});

		document.addEventListener("gtmContactFormSubmit", async (event) => {
			if (!event.detail) return;

			VgGtm.pushRegisterEventToDataLayer(
				'form_interaction',
				{},
				{ 
					event_category: 'contacto',
					event_detail: event.detail.success ? 'envio_ok' : 'envio_ko',
					event_label: event.detail.success ? 'envio_ok' : event.detail.error,
					club_name: event.detail.gtm_data?.club_name ? VgGtm.formatGtmLabelSafe(event.detail.gtm_data?.club_name) : 'sin-seleccionar',
					club_region: event.detail.gtm_data?.club_region ? VgGtm.formatGtmLabelSafe(event.detail.gtm_data?.club_region) : 'sin-seleccionar',
					email_hashed: event.detail.gtm_data?.email_hashed || '',
					phone_hashed: event.detail.gtm_data?.phone_hashed || '',
				}
			);
		});

		function handleFaqsSelection(item) {
			const faq = item.closest('.vg-faqs__accordion-heading');
			const faqSection = faq?.closest('.vg-faqs__faq');

			if (!faq || !faqSection) return false;
			if (item.getAttribute('aria-expanded') === 'false') return false;

			const faqSectionTitle = faqSection?.querySelector('.vg-faqs__main-title').textContent.trim();

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'desplegar_faq',
					event_detail: faqSectionTitle,
					event_label: item.textContent.trim(),
				}
			);
			
			return true;
		}
	});
})();